import { createContext, useState } from "react";

const PostContext = createContext({});

export const PostProvider = ({ children }) => {
    const [post, setPost] = useState({});

    return (
        <PostContext.Provider value={{ post, setPost }}>
            { children }
        </PostContext.Provider>
    );
}

export default PostContext;